import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { getBoundActions } from '../../actions/index'
import { chatListStoreKey, captionsStoreKey, scheduleKey } from '../../services/live-access-events/reducers'
import { connect as connectStaticText } from '../StaticText/connect'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'

const TrackSelector = (props) => {
  const { track, setTrack, trackTitles } = props
  return (
    <div className="live-experience-track-selector">
      {trackTitles.map((title, index) => (<div
        key={title}
        className={`live-experience-track-selector__track${
          track === index ? ' live-experience-track-selector__track--active' : ''}`}
        onClick={() => {
          if (track !== index) {
            setTrack(index)
          }
        }}
      >
        {title}
      </div>))}
    </div>
  )
}

const HeartsAndChat = (props) => {
  const {
    chatVisible, setChatVisible, setCaptionsVisible, captionsVisible, showCaptions,
  } = props
  return (
    <div className="live-experience-captions-and-chat">
      {showCaptions
      && <div className="live-experience-captions-and-chat__captions-toggle">
        <Button
          type={TYPES.LINK}
          onClick={() => { setCaptionsVisible(!captionsVisible) }}
        >
          <IconV2
          className="live-experience-captions-and-chat__captions-toggle--icon"
            type={ICON_TYPES.CC}
          />
        </Button>
      </div>
      }
      <span className="live-experience-captions-and-chat__chat-toggle">
        <svg
          className={`live-experience-captions-and-chat__chat-icon${chatVisible ? ''
            : ' live-experience-captions-and-chat__chat-icon--left'}`}
          onClick={() => { setChatVisible(!chatVisible) }}
        />
      </span>
    </div>
  )
}

export const HeartsAndChatHOC = compose(
  connectRedux(
    (state) => {
      return {
        chatVisible: state.liveAccessEvents.getIn([chatListStoreKey, 'visible']),
        captionsVisible: state.liveAccessEvents.getIn([captionsStoreKey, 'visible']),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setChatVisible: actions.liveAccessEvents.setChatVisible,
        setCaptionsVisible: actions.liveAccessEvents.setCaptionsVisible,
      }
    },
  ),
)(HeartsAndChat)

const ViewScheduleButton = (props) => {
  const { staticText, setLiveAccessScheduleVisible, scheduleVisible } = props
  return (
    <div className="live-experience-control-bar__view-schedule">
      <Button
        type={TYPES.LINK}
        onClick={() => { setLiveAccessScheduleVisible(!scheduleVisible) }}
      >
        {scheduleVisible
          ? (staticText.getIn(['data', 'hideSchedule']) || 'Hide Schedule')
          : (staticText.getIn(['data', 'viewSchedule']) || 'View Schedule')}
      </Button>
    </div>
  )
}

const ViewScheduleButtonHOC = compose(
  connectRedux(
    (state) => {
      return {
        scheduleVisible: state.liveAccessEvents.getIn([scheduleKey, 'visible']),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setLiveAccessScheduleVisible: actions.liveAccessEvents.setLiveAccessScheduleVisible,
      }
    },
  ),
  connectStaticText({ storeKey: 'liveAccessSchedule' }),
)(ViewScheduleButton)

const LiveExperienceControlBar = (props) => {
  const { trackTitles } = props
  return (
    <div className="live-experience-control-bar">
      <HeartsAndChatHOC {...props} />
      <ViewScheduleButtonHOC />
      {trackTitles.size > 1
        && <TrackSelector {...props} />
      }
    </div>
  )
}

export default LiveExperienceControlBar
